<template>

  <div class="tools-symbol-wrapper">
    <div class="title">符号静音</div>
    <div class="fenju">
      <div class="zhineng"><span>智能分句模式</span><span v-if="isFenJu" style="float:right;"><span  :class="['switchText',checked?'active':'']">{{checked?'开启':'关闭'}}</span> <span> 
        <van-switch @change="changeSwitch" :value="checked" @input="$emit('update:checked',$event)" inactive-color="#DDDDDD" size="0.36rem" /></span></span> <span  style="float:right;" v-if="!isFenJu"><span class="disableText">{{disableText}}</span><span class="icon"><img src="@/views/index/images/disabal.svg" alt="" srcset=""> </span></span></div>
      <div class="desc">
        <p> 开启：智能分句开启后，将使用更自然真人的高阶模型算法，极大的提升发音人的自然度，更加媲美真人。</p>
        <p>关闭：关闭后，将优先根据标点符号进行分句，可精准控制标点符号断句时长。</p>

      </div>
    </div>
    <p v-show="(!checked||!isFenJu)" class="symbol-tips">注意：符号静音设置为全局设置，改动后全局生效</p>
    <ul  v-show="(!checked||!isFenJu)">
      <li class="head">
        <div class="txt">符号</div>
        <div class="time">静音时长 (ms)</div>
        <div class="btns">操作</div>
      </li>
      <li v-for="(item, index) in symbolList" :key="index">
        <div class="txt">{{ item.txt + item.desc }}</div>
        <div class="time">
          <div class="border-time" @click="onCustomClick(item,index)">
            {{ item.time }}
          </div>
        </div>
        <div class="btns">
          <span class="default" @click="changeDefaultState(index)">默认</span>
        </div>
      </li>
    </ul>
    <InputModal title="自定义符号静音时长:" type="number" :defaultValue="defaultValue" placeholder="请输入5000ms以内静音" :visible.sync="customInputVisible"
      @confirm="onCustomInput" />
  </div>
</template>
<script>
import SheetContainer from "../sheet-container/sheet-container.vue";
import InputModal from "@/components/input-modal/input-modal.vue";
import { Dialog }  from "vant";
import { toast } from "@/utils/util";
export default {
  props: {
    articlePunctuations: {
      // 符号静音信息
      type: Array,
      default: []
    },
    checked: {
      // 符号静音信息
      type: Boolean,
      default: false
    },
    selection: {
      // 选中信息
      type: Object,
      default: null,
    },
    speakersNotSupportAutoMute: {
      // 文中发音人是否都支持智能分句
      type: Array,
      default: () => [],
    },
  },
  components: {
    SheetContainer,
    InputModal
  },
  data() {
    return {
      selectedValue: "", //当前选中的值，未选中或者清除时值为""
      symbolList: [],
      defaultValue:200,
      customInputVisible: false, // 自定义弹窗是否显示
      symbolIndex:0,
      symbolMap: {
        stop: {
          txt: '。',
          desc: '句号'
        },
        comma: {
          txt: '，',
          desc: '逗号'
        },
        semi: {
          txt: '；',
          desc: '分号'
        },
        question: {
          txt: '？',
          desc: '问号'
        },
        exclamation: {
          txt: '！',
          desc: '感叹号'
        },
        pause: {
          txt: '、',
          desc: '顿号'
        }
      }
    };
  },
  created() {
    this.symbolList = this.articlePunctuations.map(item => {
          const key = item.split('_')[0]
          const time = item.split('_')[1]
          const txt = this.symbolMap[key].txt
          const desc = this.symbolMap[key].desc
          const editState = false
          return { key,time,txt,desc,editState }
        })
  },
  computed: {
    isFenJu() {
      return this.speakersNotSupportAutoMute.length === 0;
    },
    disableText() {
      const len = this.speakersNotSupportAutoMute.length;
      if (len > 0) {
        return (
          this.speakersNotSupportAutoMute
            .slice(0, 2)
            .map((item) => {
              return `${item.is48k ? "48k" : ""}${item.speaker.split("@").length>1?item.name:item.name+'|默认'}`;
            })
            .join("、") + `${len > 2 ? `等` : ""}暂不支持`
        );
      }
      return "当前发音人暂不支持";
    },
  },
  watch: {
   
  },
  methods: {
    // 校验选中是否合法
    // 打开自定义弹窗
    onCustomClick(item,index) {
      this.defaultValue=item.time
      this.symbolIndex = index
      this.customInputVisible = true;
    },
    changeSwitch() {
      if (this.checked) {
        Dialog.confirm({
          title: `确定要关闭智能分句模式吗？`,
          message: `关闭后发音自然度将会下降`,
          confirmButtonText:"确定",
          className: 'pop-confirm',
          getContainer: '#page-audition',
          cancelButtonText: '取消'
        })
          .then((action) => {
            if (action === 'confirm') {
              this.$emit("changeSwitch",this.checked)
            }
          }).catch(()=>{
            this.$emit('update:checked',true)
          })
          
      } else {
        this.$emit("changeSwitch",this.checked)
      }

    },
    // 自定义输入
    onCustomInput(value) {
      if (!/^[1-9][0-9]*$/.test(value)) {
        toast("静音时长必须是正整数");
        return;
      }
      if (value > 5000) {
        toast("静音时长不能超过5000ms");
        return;
      }
      this.$set(this.symbolList[this.symbolIndex], 'time', value)
      this.$emit('updateSymbolMute',this.symbolList)
    },
    changeDefaultState(index){
      this.$set(this.symbolList[index], 'time', 200)
      this.$emit('updateSymbolMute',this.symbolList)
      // const punctuations = this.__getPunctuations()
    },
  }
};
</script>
<style lang="less" scoped>
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-top: 0;
  margin-bottom: 16px;
  font-size: 32px;
  font-weight: 500;
  color: #333333;
  font-family: 'HarmonyOS_Sans_SC';
}

.symbol-tips {
  font-size: 22px;
  color: #E02020;
  height: 70px;
  line-height: 70px;
  border-top: 1px solid #E5E5E5
}
.icon{
  height: 26px;
  width: 26px;
  margin-left: 14px;
  img{
    height: 26px;
    width: 26px;
    line-height: 26px;
    vertical-align: middle;
  }
}

.fenju {
  margin-top: 24px;

  .zhineng {
    width: 686px;
    height: 40px;
    font-size: 28px;
    font-family: 'HarmonyOS_Sans_SC';
    color: #666666;
    line-height: 40px;
  }

  .desc {
    margin: 17px 0 16px 0;
    width: 686px;
    line-height: 40px;
    font-size: 24px;
    font-family: 'HarmonyOS_Sans_SC';
    color: #B8B8B8;
  }

}

.symbol-time {
  width: 56px;
  height: 28px;
  line-height: 28px;
  border-radius: 5px;
  border: 1px solid #bbbbbb;
  text-align: center;
}

ul {
  padding: 0 4px;
}
.switchText{
  float:right;
  margin-left: 10px;
  color: #B8B8B8;
  &.active{
    color: #3583FB;
  }
}
.disableText{
  color: #666666;
  font-size: 24px;
  font-family: 'HarmonyOS_Sans_SC';
}
li {
  display: flex;
  justify-content: space-between;
  color: #333;
  font-size: 28px;
  border-bottom: 2px solid #ececec;
  height: 76px;
  line-height: 76px;

  &:last-child {
    border-bottom: 0;
  }

  &.head {
    color: #999999;
    border-top: 1px solid #E5E5E5;

    .txt {
      font-size: 28px;
      color: #999999;
      padding-left: 0;
    }
  }

  span {
    display: inline-block;
  }

  .txt {
    text-align: center;
    width: 120px;
    color: #333;
    font-size: 28px;
    box-sizing: border-box;
  }

  .time {
    width: 200px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;

    .border-time {
      width: 120px;
      height: 48px;
      border-radius: 9px;
      border: 2px solid #CEDCEF;
      line-height: 48px;
      vertical-align: middle;
    }

    .time-hov {
      display: inline-block;
      width: 58px;
      height: 28px;
      line-height: 28px;
      border-radius: 4px;
      cursor: pointer;

     
    }
  }

  .btns {
    text-align: center;
    width: 100px;
    .default{
      color: #3583FB;
    }
  }
}
</style>